import React, { PureComponent } from 'react';

import ApdexMeasuredLink from 'src/components/apdex-measured-link';
import {
  ComponentLinkProxy as ComponentLink,
  ComponentLinkProxyProps,
} from 'src/components/component-link';
import { MenuItem } from 'src/components/navigation';
import urls from 'src/components/navigation/src/urls';
import { ApdexTask } from 'src/types/apdex';

type NavigationLinkProps = Pick<
  ComponentLinkProxyProps,
  'className' | 'onClick' | 'children'
> & {
  href: string;
  menuItem?: MenuItem;
};

const taskNames: { [K: string]: ApdexTask } = {
  'overview-tab': ApdexTask.DashboardOverview,
  'profile-repositories-link': ApdexTask.ProfileRepositories,
  'repo-branches-link': ApdexTask.Branches,
  'repo-commits-link': ApdexTask.Commits,
  'repo-create-branch-link': ApdexTask.RepoCreateBranch,
  'repo-pullrequests-link': ApdexTask.PullRequests,
  'repo-source-link': ApdexTask.Source,
  'repositories-tab': ApdexTask.DashboardRepositories,
};

export default class NavigationLink extends PureComponent<NavigationLinkProps> {
  getTaskName() {
    const { href, menuItem } = this.props;

    if (href === urls.ui.root()) {
      return ApdexTask.DashboardOverview;
    }

    if (!menuItem) {
      return undefined;
    }

    if (
      menuItem.type === 'connect_menu_item' &&
      menuItem.label === 'Pipelines'
    ) {
      return ApdexTask.PipelineList;
    }

    if (menuItem.type === 'menu_item') {
      return taskNames[menuItem.id];
    }

    return undefined;
  }

  render() {
    const { children, href } = this.props;

    const task = this.getTaskName();

    if (task) {
      return (
        <ApdexMeasuredLink {...this.props} to={href} task={task}>
          {children}
        </ApdexMeasuredLink>
      );
    }

    return <ComponentLink {...this.props}>{children}</ComponentLink>;
  }
}
